// PRODUCTS
export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR"
export const EDIT_PRODUCT = 'EDIT_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const ADD_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const ADD_PRODUCT_ERROR = "GET_PRODUCT_ERROR";
export const DETAIL_PRODUCT = 'DETAIL_PRODUCT';
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const FILTER_BY_BRAND = "FILTER_BY_BRAND";
export const FILTER_BY_SIZE = "FILTER_BY_SIZE";
export const EDIT_STOCK = "EDIT_STOCK";
export const DELETE_STOCK = "DELETE_STOCK";

//USER
export const GET_USER_ID = "GET_USER_ID";
export const EDIT_USER = "EDIT_USER";
export const GET_USERS = "GET_USERS";
export const DELETE_USER = "DELETE_USER";
export const GET_ERROR_USER = "GET_ERROR_USER";
export const SEARCH_USER = "SEARCH_USER";
export const GET_ERROR_ADMIN = "GET_ERROR_ADMIN";
export const ADMIN_USER = "ADMIN_USER";
export const EDIT_PASSWORD= "EDIT_PASSWORD";
export const ADD_ADDRESS = "ADD_ADDRESS";
export const ADD_ADDRESS_ERROR = "ADD_ADDRESS_ERROR";
export const ADD_ADDRESS_SUCCESS = "ADD_ADDRESS_SUCCESS";
export const REMOVE_ADDRESS = "REMOVE_ADDRESS";
export const REMOVE_ADDRESS_SUCCESS = "REMOVE_ADDRESS_SUCCESS";
export const REMOVE_ADDRESS_ERROR = "REMOVE_ADDRESS_ERROR";


//CATEGORIES
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_ERROR_CATEGORY = 'GET_ERROR_CATEGORY';
export const GET_CATEGORY_ID = 'GET_CATEGORY_ID';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const SEARCH_CATEGORY = "SEARCH_CATEGORY";

//AUTHENTICATION
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";

export const GOOGLE_LOGIN = "GOOGLE_LOGIN";
export const GOOGLE_LOGIN_SUCCESS = "GOOGLE_LOGIN_SUCCESS";
export const GOOGLE_LOGIN_ERROR = "GOOGLE_LOGIN_ERROR";

export const REGISTER = "REGISTER";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_ERROR = "REGISTER_ERROR";

export const GET_USER_BY_ID = "GET_USER_BY_ID";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR"; 
//FILTERS
export const FILTER_BY_PRICE = "FILTER_BY_PRICE";
export const FILTER_BY_CATEGORY = "FILTER_BY_CATEGORY";
export const FILTER_BY_NAME = "FILTER_BY_NAME";

//CART
export const GET_ACTIVE_CART_FROM_USER = "GET_ACTIVE_CART_FROM_USER";
export const GET_ACTIVE_CART_FROM_USER_SUCCESS = "GET_ACTIVE_CART_FROM_USER_SUCCESS";
export const GET_ACTIVE_CART_FROM_USER_ERROR = "GET_ACTIVE_CART_FROM_USER_ERROR";

export const GET_ALL_CARTS = "GET_ALL_CARTS";
export const GET_ALL_CARTS_SUCCESS = "GET_ALL_CARTS_SUCCESS";
export const GET_ALL_CARTS_ERROR = "GET_ALL_CARTS_ERROR";
export const GET_CARTS_BY_USER = "GET_CARTS_BY_USER";  
export const ADD_TO_CART = "ADD_TO_CART";

export const ADD_ITEM = "ADD_ITEM";
export const ADD_ITEM_SUCCESS = "ADD_ITEM_SUCCESS";
export const ADD_ITEM_ERROR = "ADD_ITEM_ERROR";

export const DELETE_ITEM = "DELETE_ITEM";
export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_ERROR = "DELETE_ITEM_ERROR";

export const CHANGE_CART_STATE = "CHANGE_CART_STATE";
export const CHANGE_CART_STATE_SUCCESS = "CHANGE_CART_STATE_SUCCESS";
export const CHANGE_CART_STATE_ERROR = "CHANGE_CART_STATE_ERROR";

export const DECREMENT_PRODUCT_UNIT = "DECREMENT_PRODUCT_UNIT";
export const DECREMENT_PRODUCT_UNIT_SUCCESS = "DECREMENT_PRODUCT_UNIT_SUCCESS";
export const DECREMENT_PRODUCT_UNIT_ERROR = "DECREMENT_PRODUCT_UNIT_ERROR";

export const INCREMENT_PRODUCT_UNIT = "INCREMENT_PRODUCT_UNIT";
export const INCREMENT_PRODUCT_UNIT_SUCCESS = "INCREMENT_PRODUCT_UNIT_SUCCESS";
export const INCREMENT_PRODUCT_UNIT_ERROR = "INCREMENT_PRODUCT_UNIT_ERROR";

export const GET_CART_BY_ID_SUCCESS = "GET_CART_BY_ID_SUCCESS"
export const GET_CART_BY_ID = "GET_CART_BY_ID"
export const GET_CART_BY_ID_ERROR = "GET_CART_BY_ID_ERROR"


export const DEL_FROM_CART = "DEL_FROM_CART"
export const BUY = "BUY"
export const POST_CART = "POST_CART"





//REVIEWS
export const GET_ALL_REVIEWS = "GET_ALL_REIEWS";
export const ADD_REVIEW = "ADD_REVIEW";
export const GET_REVIEW_SUCCESS = "GET_REVIEW_SUCCES";
export const GET_REVIEW_ERROR = "GET_REVIEW_ERROR";
export const ADD_REVIEW_SUCCESS = "ADD_REVIEW_SUCCESS";
export const ADD_REVIEW_ERROR = "ADD_REVIEW_ERROR";
export const GET_REVIEWS_ID = "GET_REVIEWS_ID"
export const FILTER_BY_ID = "FILTER_BY_ID"
//URL
export const URL = "https://ecommerce-adalove.herokuapp.com/"
